import { render, staticRenderFns } from "./ContactUsPage.vue?vue&type=template&id=8ca856c8"
import script from "./ContactUsPage.vue?vue&type=script&lang=js"
export * from "./ContactUsPage.vue?vue&type=script&lang=js"
import style0 from "./ContactUsPage.vue?vue&type=style&index=0&id=8ca856c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports